// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".campaign-detail-tbody .tbody-empty{flex-grow:0}.campaign-detail-tbody .tbody-name{min-width:50%;max-width:50%}.campaign-detail-table .empty{flex-grow:.5}.campaign-detail-table .name{flex-grow:11}.campaign-detail-table .status{flex-grow:3}.campaign-detail-table .actions{flex-grow:1.5;text-align:center}.adset-tbody .empty{flex-grow:0;min-width:5%}.adset-tbody .tbody-name{min-width:60%;max-width:60%}", ""]);
// Exports
module.exports = exports;
